exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3YEY7{position:relative;padding:0 18px 16px;border-bottom:1px solid #d8d8d8;font-weight:400;cursor:default;min-height:100px}.O5qCD{font-size:21px;margin-bottom:4px;font-weight:700;max-width:500px}._2iiiq{font-size:12px;color:#aaa;font-weight:400;margin:0}.-OhIt,._33HfE,._86jLf{color:#999;font-size:12px;display:inline-block;margin-right:20px}._86jLf>i{font-size:14px;margin-right:.2em}._1-Ziq{font-size:22px;text-align:right;width:100%}._1-Ziq._1zZlw{font-size:16px}.QSUFp{margin-bottom:2px}._2wKv2{font-size:22px;font-weight:700;white-space:nowrap}._2wKv2:not(:first-of-type){font-weight:400;font-size:14px}.d4RBv{margin-left:-7px}._1LNbl,.d4RBv{display:inline-block}._1LNbl{vertical-align:top;font-weight:600;padding:5px 10px;font-size:14px;background:#ffd906;border-radius:2px;color:#000;text-decoration:none;margin:1px 0 27px}._1LNbl:hover{background:#ffc107}._3kKxg{display:flow-root;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}._3qEzT{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}._2TA_c{padding:20px 15px}._1Kbt8{overflow-y:auto;max-height:100vh;margin:0 auto}._3S-cy{position:relative;border-radius:10px;max-width:330px}._1Drn7,._2Dmhl{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px;color:#c4c4c4}._2Dmhl:before{content:\"\\D7\"}._26G-D{font-size:12px}._26G-D>i[class$=fa-car]{font-size:12px;margin-left:4px}", ""]);

// exports
exports.locals = {
	"root": "_3YEY7",
	"title": "O5qCD",
	"h1": "_2iiiq",
	"id": "-OhIt",
	"date": "_33HfE",
	"views": "_86jLf",
	"price": "_1-Ziq",
	"contractPrice": "_1zZlw",
	"priceList": "QSUFp",
	"priceItem": "_2wKv2",
	"favoriteContainer": "d4RBv",
	"clarifyPrice": "_1LNbl",
	"blockRightFlex": "_3kKxg",
	"yearSection": "_3qEzT",
	"rootModalLeasing": "_2TA_c",
	"rootModal": "_1Kbt8",
	"modal": "_3S-cy",
	"closeBtnIcon": "_1Drn7",
	"closeBtn": "_2Dmhl",
	"titleLeasingLink": "_26G-D"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/AdvertTitle/AdvertTitle.css
// module id = 3123
// module chunks = 36